import { render, staticRenderFns } from "./vf-drawer-size-editor.vue?vue&type=template&id=86d983b4&scoped=true&"
import script from "./vf-drawer-size-editor.vue?vue&type=script&lang=js&"
export * from "./vf-drawer-size-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d983b4",
  null
  
)

export default component.exports